<template>
  <div class="pa-message-additional-box">
    <div
     class="pa-infomation-tag-menu"
     :class="additionalClass"
     v-for="(listSet, key) in tagMenuList"
     :key="key"
    >
      <h3>{{listSet.label}}</h3>
      <form class="tag-menu-list">
        <TagMenuButton
          v-for="item in listSet.list"
          :key="item.slug"
          :item="item"

          @onClick="handleClickTagMenu"
        />
      </form>
    </div>
  </div>
</template>

<script>
import TagMenuButton from '@/components/Pages/Office/MessageApp/Additionals/TagMenuButton.vue';

export default {
  props : {
    isDisabled  : {
      default: false,
    }
  },

  components : {
    TagMenuButton
  },

  data(){
    return {
      tagMenuList : {
        creation : {
          label : '新規申請',
          list  : [
            {
              slug            : 'createNewPark',
              label           : '秘密のひろばを新設したい',
              styleType       : 'long',
              isLoading       : false,
              isDisabled      : false,
            }
          ]
        },

        basic : {
          label : '変更申請',
          list  : [
            {
              slug            : 'changeName',
              label           : '名前を変えたい',
              styleType       : 'mini',
              isLoading       : false,
              isDisabled      : false,
            },
            {
              slug            : 'changePassword',
              label           : 'パスワードを変えたい',
              styleType       : 'mini',
              isLoading       : false,
              isDisabled      : false,
            },
            {
              slug            : 'changeEmail',
              label           : 'メールアドレスを変えたい',
              styleType       : 'long',
              isLoading       : false,
              isDisabled      : false,
            },
            {
              slug            : 'changeThumbnail',
              label           : 'サムネイルを変えたい',
              styleType       : 'mini',
              isLoading       : false,
              isDisabled      : false,
            },
            {
              slug            : 'leave',
              label           : '退会したい',
              styleType       : 'mini',
              isLoading       : false,
              isDisabled      : false,
            },
            {
              slug            : 'notification',
              label           : '外部通知設定',
              styleType       : 'mini',
              isLoading       : false,
              isDisabled      : false,
            },
            {
              slug            : 'modalNotification',
              label           : '内部通知設定',
              styleType       : 'mini',
              isLoading       : false,
              isDisabled      : false,
            },
            {
              slug            : 'logout',
              label           : 'ログアウトしたい',
              styleType       : 'long',
              isLoading       : false,
              isDisabled      : false,
            },
          ],
        },

        etc : {
          label : 'その他',
          list  : [
            {
              slug            : 'registParkInvitation',
              label           : 'ひろば通行手形を使用',
              styleType       : 'long',
              isLoading       : false,
              isDisabled      : false,
            },
            {
              slug            : 'registNumber',
              label           : '特別番号登録',
              styleType       : 'long',
              isLoading       : false,
              isDisabled      : false,
            },
            {
              slug            : 'checkApplicationStatus',
              label           : '申請状況の確認',
              styleType       : 'long',
              isLoading       : false,
              isDisabled      : false,
            },
            {
              slug            : 'startTutorial',
              label           : 'チュートリアルを開始',
              styleType       : 'long',
              isLoading       : false,
              isDisabled      : false,
            }
          ]
        }
      },

      additionalClass : {
        'is-disabled' : false,
      },
    };
  },

  watch : {
    isDisabled : {
      handler(value){
        if(value === true){
          this.additionalClass['is-disabled'] = true;

          this.disableAllMenu();
        }else{
          this.additionalClass['is-disabled'] = false;

          this.unDisabledAllMenu();
        }
      },
      immediate:true
    }
  },

  methods : {
    async handleClickTagMenu(item){
      this.disableAllMenu();

      item.isLoading = true;

      await this.UXWaiting(800);

      this.$emit('handleClickAdditionalMenuButton', item);
    },

    unDisabledAllMenu(){
      for(let menuName in this.tagMenuList){
        for(let i = 0; i < this.tagMenuList[menuName].list.length; i++){
          this.tagMenuList[menuName].list[i].isDisabled = false;
        }
      }
    },

    disableAllMenu(){
      for(let menuName in this.tagMenuList){
        for(let i = 0; i < this.tagMenuList[menuName].list.length; i++){
          this.tagMenuList[menuName].list[i].isDisabled = true;
        }
      }
    }
  }
}
</script>

<style lang="scss">
div.pa-message-additional-box{
  .pa-infomation-tag-menu{
    background-color:#A6D7C5;
    border-radius:4px;
    padding:0 .3rem .3rem;
    margin-top:.5rem;
    user-select: none;

    h3{
      width:35%;
      display:block;
      margin:0 auto;
      text-align: center;
      color:#547166;
      font-size:1rem;
      margin-bottom:.5rem;
      background-color:#8FC1AF;
      padding:.4rem 0;
      border-radius:0 0 4px 4px;
      border-top:4px solid #69A28D;
    }

    form.tag-menu-list{
      margin:0;
      padding:0;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    &.is-disabled{
      h3{
        color:#678a7d;
        background-color:#9bd6c0;
        border-top:4px solid #81c5ac;
      }
    }
  }
}

.pa-message-set{
  &-default{
    div.pa-message-additional-box{
      .pa-infomation-tag-menu{
        background-color:#A6D7C5;

        h3{
          color:#547166;
          background-color:#8FC1AF;
          border-color:#69A28D;
        }

        &.is-disabled{
          h3{
            color:#678a7d;
            background-color:#9bd6c0;
            border-color:#81c5ac;
          }
        }
      }
    }
  }

  &-lilica{
    div.pa-message-additional-box{
      .pa-infomation-tag-menu{
        background-color:#dda6e0;

        h3{
          color:#745975;
          background-color:#de95e0;
          border-color:#b05ab3;
        }

        &.is-disabled{
          h3{
            color:#826783;
            background-color:#d48fd6;
            border-color:#9f52a1;
          }
        }
      }
    }
  }
}
</style>